import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Hero from "../components/Hero";
import BrandSlider from "../components/BrandSlider";
import Services from "../components/Services";
import ServiceShowcase from "../components/ServiceShowcase";
import WhyChoose from "../components/Whychoose";
import Timeline from "../components/Timeline";
import Reviews from "../components/Reviews";

import "./Home.css";

const Home = () => {
  useEffect(() => {
    document.body.classList.add("home-snap");
    return () => document.body.classList.remove("home-snap");
  }, []);

  return (
    <>
  <Helmet>
  {/* Primary SEO */}
  <title>
    Servizy | Trusted Mobile Repair Service in Bangalore
  </title>

  <meta
    name="description"
    content="Servizy provides reliable doorstep mobile repair services in Bangalore for screen replacement, battery repair, charging issues, and software support for all major smartphone brands."
  />

  <meta
    name="keywords"
    content="mobile repair Bangalore, phone repair Bangalore, doorstep mobile repair, smartphone repair service, mobile service center"
  />

  <meta
    name="robots"
    content="index, follow"
  />

  {/* Author */}
  <meta
    name="author"
    content="Servizy"
  />

  {/* Publisher */}
  <meta
    name="publisher"
    content="Servizy"
  />

  <meta
    property="article:publisher"
    content="https://servizy.co.in/"
  />

  {/* Canonical */}
  <link
    rel="canonical"
    href="https://servizy.co.in/"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Servizy | Trusted Mobile Repair Service in Bangalore"
  />

  <meta
    property="og:description"
    content="Servizy provides reliable doorstep mobile repair services in Bangalore for screen replacement, battery repair, charging issues, and software support for all major smartphone brands."
  />

  <meta
    property="og:image"
    content="https://servizy.co.in/s.png"
  />

  <meta
    property="og:url"
    content="https://servizy.co.in/"
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:site_name"
    content="Servizy"
  />

  {/* Twitter SEO */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Servizy | Trusted Mobile Repair Service in Bangalore"
  />

  <meta
    name="twitter:description"
    content="Servizy provides reliable doorstep mobile repair services in Bangalore for screen replacement, battery repair, charging issues, and software support for all major smartphone brands."
  />

  <meta
    name="twitter:image"
    content="https://servizy.co.in/s.png"
  />

  {/* Geo SEO */}
  <meta
    name="geo.region"
    content="IN-KA"
  />

  <meta
    name="geo.placename"
    content="Bangalore"
  />

  <meta
    name="language"
    content="English"
  />

  {/* Mobile SEO */}
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1"
  />

  {/* Theme Color */}
  <meta
    name="theme-color"
    content="#0a84ff"
  />
</Helmet>

      {/* ================= PAGE ================= */}
      <main className="home-page">
        <Hero />
       
        <BrandSlider />
        <Services />
        <WhyChoose />
        <Timeline />
        <Reviews />
         <ServiceShowcase />
      </main>
    </>
  );
};

export default Home;
